import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MxSelector, MxSelectorCreator} from '@aviary/store/store.types';
import {createSelector} from '@ngrx/store';
import {RouterSelectors} from '@aviary/store/router/router.selectors';
import {TableCardHeaderFilterDefinitions} from '@aviary/components/table-card/table-card-header-filters/table-card-header-filter.types';
import {ActionButtonsComponent} from '@aviary/components/action-buttons/action-buttons.component';
import {
  TableCardHeaderFilterComponent
} from '@aviary/components/table-card/table-card-header-filters/table-card-header-filter/table-card-header-filter.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';

@Component({
  selector: 'mx-table-card-header-filters',
  template: `
    <mx-action-buttons>
      @for (definition of sortedDefinitions | select; track definition.queryParamName) {
        <mx-table-card-header-filter [definition]="definition"/>
      }
    </mx-action-buttons>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionButtonsComponent, TableCardHeaderFilterComponent, SelectPipe]
})
export class TableCardHeaderFiltersComponent {

  @Input() set definitions(definitions: TableCardHeaderFilterDefinitions) {
    this.sortedDefinitions = sortedDefinitionsSelectorCreator(definitions);
  }

  public sortedDefinitions: MxSelector<TableCardHeaderFilterDefinitions>;
}

// Active filters move to the front of the list.  Other than that, we want the filter buttons to maintain their original order.
const sortedDefinitionsSelectorCreator: MxSelectorCreator<[TableCardHeaderFilterDefinitions], TableCardHeaderFilterDefinitions> =
  _definitions => createSelector(
    RouterSelectors.queryParamNames,
    paramNames => {
      if (!_definitions) return [];

      return _definitions.reduce<TableCardHeaderFilterDefinitions>(
        (accumulator, definition) =>
          paramNames.includes(definition.queryParamName)
            ? [definition, ...accumulator]
            : [...accumulator, definition],
        []
      );
    });
